import type { Quote } from "~/v2/api/rest/data";

export const getAssetQuotePricing = (quote: Quote) => {
  const price =
    quote.ask !== undefined && quote.bid !== undefined
      ? (quote.ask + quote.bid) / 2
      : quote.last;
  const last = quote.last ?? 0;
  const lastClose = Number.parseFloat(quote.last_day_closing ?? "");
  const hasPreviousClose =
    quote.last !== undefined && Number.isFinite(lastClose) && lastClose > 0;
  const dailyChange = hasPreviousClose ? last - lastClose : undefined;
  const dailyChangePercent =
    hasPreviousClose && dailyChange !== undefined
      ? dailyChange / lastClose
      : undefined;

  return { price, dailyChange, dailyChangePercent };
};
